<template>
  <div v-if="$store.state.responsive.viewDesktopFilters" id="renews-filters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="name">Nombre</label>
            <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
          </div>
        </div> -->
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="surnames">Apellidos</label>
            <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
          </div>
        </div> -->
        <!-- <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber">DNI</label>
            <input type="text" class="form-control generalInput" id="documentNumber" v-model.trim="documentNumber">
          </div>
        </div> -->
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="contractNumber">Nº Contrato</label>
            <input type="text" class="form-control generalInput" id="contractNumber" v-model.trim="contractNumber">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="parentContractId">Nº Contrato antiguo</label>
            <input type="text" class="form-control generalInput" id="parentContractId" v-model.trim="parentContractId">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="from">Desde</label>
            <DatePicker v-model="from" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="from" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="to">Hasta</label>
            <DatePicker v-model="to" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="to" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="status">Estado</label>
            <VueNextSelect class="form-control generalInput" :options="statusesEsp" v-model.trim="status" placeholder=""
              close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber"
                v-model.trim.lazy="v$.documentNumber.$model">
              <div v-if="v$.documentNumber.$dirty">
                <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 d-flex justify-content-end align-items-end">
          <div class="d-flex justify-content-end align-items-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>

            <!-- Botón de buscar con spinner -->


            <button class="btn btn-primary generalPrimaryButton" :disabled="isLoading || buttonLoading">
              <span v-if="isLoading || buttonLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-if="!isLoading && !buttonLoading">Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="name">Nombre</label>
              <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
            </div>
          </div> -->
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="surnames">Apellidos</label>
              <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
            </div>
          </div> -->
          <!-- <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber" v-model.trim="documentNumber">
            </div>
          </div> -->
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="contractNumber">Nº Contrato</label>
              <input type="text" class="form-control generalInput" id="contractNumber" v-model.trim="contractNumber">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="parentContractId">Nº Contrato antiguo</label>
              <input type="text" class="form-control generalInput" id="parentContractId" v-model.trim="parentContractId">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="from">Desde</label>
              <DatePicker v-model="from" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="from" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="to">Hasta</label>
              <DatePicker v-model="to" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="to" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="status">Estado</label>
              <VueNextSelect class="form-control generalInput" :options="statusesEsp" v-model.trim="status" placeholder=""
                close-on-select>
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
                <label class="generalLabel" for="documentNumber">DNI</label>
                <input type="text" class="form-control generalInput" id="documentNumber"
                  v-model.trim.lazy="v$.documentNumber.$model">
                <div v-if="v$.documentNumber.$dirty">
                  <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
                    formato no es correcto</small>
                </div>
              </div>
          </div>
          <div class="col-12 col-lg-6 d-flex justify-content-end align-items-end">
            <div class="d-flex justify-content-end align-items-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <!-- Botón de buscar con spinner -->
              <button class="btn btn-primary generalPrimaryButton" :disabled="isLoading || buttonLoading">
                <span v-if="isLoading || buttonLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="!isLoading && !buttonLoading">Buscar</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { DatePicker } from 'v-calendar';
import VueNextSelect from 'vue-next-select';
import useVuelidate from '@vuelidate/core';

const dniNumber = (value) => {
  if (value != '') {
    var numero, le, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    value = value.toUpperCase();

    if (expresion_regular_dni.test(value) === true) {
      numero = value.substr(0, value.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      le = value.substr(value.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != le) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return true
  }
}

export default {
  name: 'ContractFilters',
  components: {
    DatePicker,
    VueNextSelect,
  },
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    filterURL: String,
    isLoading: Boolean,
  },

  data() {
    return {
      buttonLoading: false,
      contractNumber: '',
      parentContractId: '',
      from: '',
      to: '',
      documentNumber: '',
      status: '',
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      statuses: ['CREATED', 'PENDING_CUSTOMER_APPROVAL', 'APPROVED_BY_CUSTOMER', 'REJECTED_BY_CUSTOMER', 'APPROVED_BY_BO', 'REJECTED_BY_BO', 'RENEWAL_FEE_PAYMENT_COMPLETED', 'RENEWAL_FEE_PAYMENT_FAILED', 'CONTRACT_RENEWAL_INITIAL_PAYMENT_ON_HOLD', 'PARENT_CONTRACT_CANCELLED', 'COMPLETED', 'CANCELLED', 'PENDING_LOGISTICS_PROCESSING'],
      statusesEsp: ['CREADO', 'PENDIENTE CONFIRMACIÓN DEL CLIENTE', 'APROBADO POR CLIENTE', 'RECHAZADO POR CLIENTE', 'APROBADO POR BO', 'RECHAZADO POR BO', 'COBRO DE CUOTA DE RENOVACIÓN EXITOSA', 'COBRO DE CUOTA DE RENOVACIÓN FALLIDA', 'CUOTA INICIAL DE NUEVO CONTRATO EN HOLD', 'CONTRATO ANTERIOR CANCELADO', 'COMPLETADO', 'CANCELADO', 'PROCESO DE LOGÍSTICA PENDIENTE'],
    };
  },
  mounted() {
    if(this.filterURL && this.filterURL !== '') {
      let indexStatus = this.statuses.indexOf(decodeURIComponent(this.filterURL));
      let filterURLEsp = this.statusesEsp[indexStatus];
      this.$nextTick(() => {
        this.status =filterURLEsp;
      })
      this.$nextTick(() => {
        this.filter();
      })
    }
  },
  computed: {
    filtersApplied() {
      // `this` apunta a la instancia vm
      return {
        contractNumber: this.contractNumber,
        parentContractId: this.parentContractId,
        from: this.from,
        to: this.to,
        documentNumber: this.documentNumber,
        status: this.statuses[this.statusesEsp.indexOf(this.status)]
      };
    },
  },
  validations() {
    return {
      documentNumber: {
        dniNumber,
      }
    }
  },
  methods: {
    async filter() {
      try {
        this.buttonLoading = true;  // Activamos el spinner del botón
        await this.$emit('filter', this.filtersApplied);  // Emitimos el evento para el componente padre
      } catch (error) {
        console.error("Error en la búsqueda: ", error);
      } finally {
        this.buttonLoading = false;  // Apagamos el spinner del botón después del éxito o fallo
      }
    },
    cleanSearch() {
      this.contractNumber = '';
      this.parentContractId = '';
      this.from = '';
      this.to = '';
      this.documentNumber = '';
      this.status = '';
      this.filtersApplied.status = ''
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}
.link-primary {
  color:$primary;
  cursor:pointer;

  &:hover {
    color: $primary-hover;
  }
}
.spinner-border {
  margin-right: 5px;
}
</style>
